import { MainDrawDay } from 'constants/Draw';
import React from 'react';
import DrawDaysSelector from '../DrawDaysSelector';
import MembershipSummary from '../MembershipSummary';
import V1EnterLayout from './V1EnterLayout';
import V1EntriesPicker from './V1EntriesPicker';

interface V1EntriesAndDaysProps {
  nextDrawDay: MainDrawDay;
}

export const V1EntriesAndDays: React.FC<V1EntriesAndDaysProps> = ({
  nextDrawDay,
}) => {
  return (
    <V1EnterLayout
      desktopLeft={
        <>
          <V1EntriesPicker />
          <DrawDaysSelector nextDrawDay={nextDrawDay} />
        </>
      }
      desktopRight={
        <>
          <MembershipSummary onLightBackground showMascot />
        </>
      }
      mobileView={
        <>
          <V1EntriesPicker />
          <DrawDaysSelector nextDrawDay={nextDrawDay} />
          <MembershipSummary onLightBackground />
        </>
      }
    />
  );
};

export default V1EntriesAndDays;
